import { useGetPromptQuery, useGetTipsQuery } from '@/features/search/api/search.api'

const getSearchValue = (value: string): string => {
	if (value.length > 3) {
		return value
	}

	return ''
}

export const useHeaderSearch = (value = '') => {
	const searchValue = getSearchValue(value)
	const { data: tipsData, isFetching } = useGetTipsQuery({ value: searchValue })
	const { data: promptsData } = useGetPromptQuery()

	const products = tipsData?.ITEMS ?? []
	const categories = tipsData?.CATEGORIES ?? []
	const tips = tipsData?.TIPS ?? []
	const history = tipsData?.HISTORY ?? []
	const prompts = promptsData ?? []
	const redirectUrl = tipsData?.REDIRECT_URL ?? ''
	const isLoading = isFetching

	const haveData = [products, categories, tips, history].some(item => item?.length > 0)

	return {
		products,
		categories,
		tips,
		history,
		prompts,
		redirectUrl,
		isLoading,
		haveData
	}
}
